import React from 'react';

interface XmlExtProps {
    width?: number;
    height?: number;
}

export const XmlExt = ({ height = 26, width = 26 }: XmlExtProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 104 104"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_6434_40579)">
            <path
                d="M93.3075 20.4426L73.8075 0.942554C73.5038 0.641348 73.1437 0.403047 72.7477 0.241313C72.3517 0.0795786 71.9277 -0.00240796 71.5 5.38383e-05H19.5C14.1152 5.38383e-05 9.75 4.36521 9.75 9.75005V94.2501C9.75 99.6349 14.1152 104 19.5 104H84.5C89.8848 104 94.25 99.6349 94.25 94.2501V22.7501C94.2525 22.3223 94.1705 21.8983 94.0088 21.5023C93.847 21.1064 93.6087 20.7462 93.3075 20.4426ZM87.75 94.2501C87.75 96.0451 86.295 97.5001 84.5 97.5001H19.5C17.705 97.5001 16.25 96.0451 16.25 94.2501V9.75005C16.25 7.95504 17.705 6.50005 19.5 6.50005H68.25V19.5001C68.25 23.0899 71.1602 26.0001 74.75 26.0001H87.75V94.2501Z"
                fill="#D7D7D7"
            />
            <path
                d="M80 84.6667C80 86.5 78.5 88 76.6667 88H3.33333C1.5 88 0 86.5 0 84.6667V51.3333C0 49.5 1.5 48 3.33333 48H76.6667C78.5 48 80 49.5 80 51.3333V84.6667Z"
                fill="#84BD5A"
            />
            <path
                d="M17.2188 58.3636L21.9169 66.0437H22.0703L26.7685 58.3636H30.201L24.0838 68.1818L30.2393 78H26.7876L22.0703 70.4254H21.9169L17.1996 78H13.7479L20.0089 68.1818L13.7862 58.3636H17.2188ZM31.5197 58.3636H35.1153L41.3667 73.6278H41.5968L47.8482 58.3636H51.4437V78H48.6249V63.7905H48.4427L42.6515 77.9712H40.312L34.5208 63.7809H34.3386V78H31.5197V58.3636ZM54.1312 78V58.3636H57.0939V75.4496H65.9916V78H54.1312Z"
                fill="white"
            />
        </g>
        <defs>
            <clipPath id="clip0_6434_40579">
                <rect width="104" height="104" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
